"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFeeTable = exports.GasPrice = void 0;
const math_1 = require("@cosmjs/math");
const proto_signing_1 = require("@cosmjs/proto-signing");
/**
 * This is the same as GasPrice from @cosmjs/launchpad but those might diverge in the future.
 */
class GasPrice {
    constructor(amount, denom) {
        this.amount = amount;
        this.denom = denom;
    }
    static fromString(gasPrice) {
        const matchResult = gasPrice.match(/^(?<amount>.+?)(?<denom>[a-z]+)$/);
        if (!matchResult) {
            throw new Error("Invalid gas price string");
        }
        const { amount, denom } = matchResult.groups;
        if (denom.length < 3 || denom.length > 127) {
            throw new Error("Gas price denomination must be between 3 and 127 characters");
        }
        const fractionalDigits = 18;
        const decimalAmount = math_1.Decimal.fromUserInput(amount, fractionalDigits);
        return new GasPrice(decimalAmount, denom);
    }
}
exports.GasPrice = GasPrice;
/**
 * This is the same as calculateFee from @cosmjs/launchpad but those might diverge in the future.
 */
function calculateFee(gasLimit, { denom, amount: gasPriceAmount }) {
    const amount = Math.ceil(gasPriceAmount.multiply(new math_1.Uint53(gasLimit)).toFloatApproximation());
    return {
        amount: proto_signing_1.coins(amount, denom),
        gas: gasLimit.toString(),
    };
}
/**
 * This is the same as buildFeeTable from @cosmjs/launchpad but those might diverge in the future.
 */
function buildFeeTable(gasPrice, defaultGasLimits, gasLimits) {
    return Object.entries(defaultGasLimits).reduce((feeTable, [type, defaultGasLimit]) => (Object.assign(Object.assign({}, feeTable), { [type]: calculateFee(gasLimits[type] || defaultGasLimit, gasPrice) })), {});
}
exports.buildFeeTable = buildFeeTable;
//# sourceMappingURL=fee.js.map